<template lang="pug">
  .empty
    .empty-icon
      i(:class="iconClass" v-if="iconClass")
    p.empty-title.h5 {{ title }}
    p.empty-subtitle {{ subtitle }}
    slot
</template>

<script>
export default {
  props: {
    iconClass: { type: String, default: 'fa-5x fas fa-folder-open' },
    title: { type: String, default: 'Nada encontrado' },
    subtitle: { type: String, default: 'Não encontramos nenhum resultado' },
  },
}
</script>
